var _defs, _path, _path2, _path3, _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVe = function SvgVe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-5L-1.545-.245l2.853.927z",
    id: "a",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)",
    width: 180,
    height: 120
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)",
    width: 180,
    height: 120
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(-72)",
    width: 180,
    height: 120
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)",
    width: 180,
    height: 120
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0z",
    fill: "#cf142b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v320H0z",
    fill: "#00247d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v160H0z",
    fill: "#fc0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f",
    transform: "matrix(4 0 0 4 320 336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(10)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(30)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(40)",
    xlinkHref: "#e"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(-80 320 336)",
    xlinkHref: "#f"
  })));
};
export default __webpack_public_path__ + "assets/0cf429245b9a24cbe0e17248d4d5ecca.svg";
export { SvgVe as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ve.svg